import { createTheme, ThemeOptions } from '@mui/material/styles';
import { hoverFix } from './styles/mixins';

// @see https://www.figma.com/file/jxOa0gW2PdUH07wacIHF9M/Mindtickle-integration
export const MindTickleThemeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: '#4D7CC7',
      light: '#fff',
    },
    secondary: {
      dark: '#588CE0',
      main: '#4D7CC7',
    },
    error: {
      main: '#FF6969',
    },
    icon: {
      main: '#4D7CC7',
    },
    common: {
      white: '#fff',
      black: '#000',
    },
  },
  typography: {
    fontFamily: 'Inter, Arial, sans-serif',
  },
  components: {
    MuiAutocomplete: {
      styleOverrides: {
        listbox: {
          '& .MuiAutocomplete-option[aria-selected="true"], & .MuiAutocomplete-option[aria-selected="true"].Mui-focused':
            {
              backgroundColor: 'rgba(0, 0, 0, 0.08)',
            },
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          fontWeight: 500,
          textTransform: 'capitalize',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        outlinedSecondary: {
          backgroundColor: 'white',
        },
        root: {
          fontWeight: 500,
          textTransform: 'capitalize',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          ...hoverFix,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          ...hoverFix,
          '& .MuiListItemIcon-root': {
            minWidth: '24px',
          },
          '& .MuiListItemText-root': {
            marginBottom: '4px',
            marginTop: '4px',
          },
        },
      },
    },
    MuiTooltip: {
      defaultProps: {
        arrow: true,
      },
      styleOverrides: {
        arrow: {
          color: 'var(--tooltip-solid-color)',
        },
        tooltip: {
          backgroundColor: 'var(--tooltip-solid-color)',
        },
      },
    },
  },
};

export default createTheme(MindTickleThemeOptions);
